<template>
  <tab-page-template
      :fit="fit"
      :maximizable="maximizable"
      @tab-change="handleTabChange"
      @pane-resizing="$emit('pane-resizing')">
    <template #toolbar-items v-if="showToolbar">
      <el-tooltip content="確定" placement="bottom" v-if="showApplyButtonFinally">
        <v-btn icon color="green" :disabled="!dirty || !valid" @click="doSave">
          <v-icon>mdi-check-bold</v-icon>
        </v-btn>
      </el-tooltip>
      <slot name="toolbar-items"></slot>
    </template>

    <template #default>
      <slot name="before-form"></slot>
      <v-form v-model="valid">
        <template v-if="noPadding">
          <slot></slot>
        </template>
        <template v-else>
          <v-container class="form-container" :fluid="fluid">
            <slot></slot>
          </v-container>
        </template>
      </v-form>
      <slot name="after-form"></slot>
    </template>

    <template #left-tabs>
      <slot name="left-tabs"></slot>
    </template>
    <template #tab-items>
      <slot name="tab-items"></slot>
    </template>
    <template #right-tabs>
      <slot name="right-tabs"></slot>
    </template>

    <template #after-tabs>
      <slot name="after-tabs"></slot>
    </template>
  </tab-page-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";

export default {
  name: "FormPageTemplate",
  components: {TabPageTemplate},
  mixins: [PathInfoMixin],
  props: {
    dirty: {
      type: Boolean,
      required: true
    },
    showApplyButton: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    fit: {
      type: Boolean,
      default: false
    },
    maximizable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    showApplyButtonFinally() {
      return this.showApplyButton || this.isEditable;
    },
    showToolbar() {
      return !!this.$slots['toolbar-items']?.length || this.showApplyButtonFinally;
    }
  },
  methods: {
    doSave() {
      this.$emit('save');
    },
    handleTabChange(value) {
      this.$emit('tab-change', value);
    }
  }
}
</script>

<style lang="css" scoped>
.form-container {
  padding-top: 0;
}
</style>
